/**
 * StrategyIntro — page title + co-CEO narrator for Strategy Insights.
 *
 * Authority: docs/contracts/DESIGN_IMPLEMENTATION_CONTRACT.md §5 (coceoVoice: active) + §8.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DS_COLORS, DS_SPACING, DS_TYPOGRAPHY } from '@/config/ui-invariants';
import { copy } from '@/content/copy';
import { CoCeoVoiceBlock } from '@/components/shared/CoCeoVoiceBlock';

export function StrategyIntro({ introData }) {
  return (
    <header style={{ marginBottom: DS_SPACING.cardGap * 2 }}>
      <h1
        style={{
          ...DS_TYPOGRAPHY.pageTitle,
          color: DS_COLORS.text.primary,
          margin: 0,
        }}
      >
        {copy.strategyInsights.intro.title}
      </h1>
      <CoCeoVoiceBlock
        template={copy.strategyInsights.intro.coceoVoiceTemplate}
        data={introData}
      />
    </header>
  );
}

StrategyIntro.propTypes = {
  introData: PropTypes.object,
};

export default StrategyIntro;
